import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import { MoleculeIcon } from '@repo/ui/icons'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { toast } from 'sonner'

import { getFormula } from '../../../../api/formula/get-formula-by-id'
import { updateFormula } from '../../../../api/formula/update-formula'
import { Paths } from '../../../../lib/constants/path'
import { updateButtonsConfig } from '../../../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../../../lib/utils/functions/misc.functions'
import NotFoundPage from '../../../../views/common/not-found'
import { ItemNotFound } from '../../../elements/item-not-found'
import LoadingScreen from '../../../elements/loading/loading-screen'
import UserNavBar from '../../../elements/nav-bar'
import JourneyPlaceFormulaForm from './journey-place-formula-form'
import { mapFormulaToInput } from './utils'

const JourneyPlaceFormulaUpdatePage = () => {
  const { id } = useParams<{ id: string }>()
  const queryClient = useQueryClient()
  const { navigate, back } = useNavigator()

  if (!id || isNaN(parseInt(id))) return <ItemNotFound title="Identifiant de formule invalide" />

  const { mutateAsync } = useMutation({
    mutationFn: updateFormula,
    onError: showAxiosError,
    onSuccess() {
      queryClient.invalidateQueries({ exact: true, queryKey: ['formula', id] })
      toast.success('Formule modifiée avec succès')
    }
  })

  const { data, isLoading } = useQuery({
    queryKey: ['formula', id],
    queryFn: () => getFormula(+id)
  })

  if (isLoading) return <LoadingScreen />
  if (!data) return <NotFoundPage />

  return (
    <div>
      <UserNavBar
        title="Modifier une formule"
        icon={(props) => <MoleculeIcon {...props} fill={tailwindColors.secondary.DEFAULT} />}
      />
      <div className={'h-4'} />
      <Box>
        <JourneyPlaceFormulaForm
          defaultValues={mapFormulaToInput(data)}
          buttonsConfig={updateButtonsConfig({
            onCancel: () => back(Paths.FORMULA_WISH_LIST),
            onUpdate: (values) => mutateAsync({ id: data.id, ...values }),
            onUpdateThenCreate: async (values) => {
              await mutateAsync({ id: data.id, ...values })
              navigate(Paths.FORMULA_WISH_LIST_CREATE_PAGE)
            },
            onUpdateThenList: async (values) => {
              await mutateAsync({ id: data.id, ...values })
              back(Paths.FORMULA_WISH_LIST)
            }
          })}
        />
      </Box>
    </div>
  )
}

export default JourneyPlaceFormulaUpdatePage
